import { render, staticRenderFns } from "./YachtDetails.vue?vue&type=template&id=1072fdca&"
import script from "./YachtDetails.vue?vue&type=script&lang=js&"
export * from "./YachtDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports